import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { MobileSessionService } from "../auth/mobile-session.service";
import { MobileAuthStore } from "../state/mobile-auth.store";
import { mobilePath } from "./mobile-routes.constants";

export const mobileAuthGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const sessionService = inject(MobileSessionService);
  const authStore = inject(MobileAuthStore);

  if (authStore.workflowState() === "idle") {
    await sessionService.bootstrapSession();
  }

  if (authStore.isAuthenticated()) {
    return true;
  }

  return router.parseUrl(mobilePath("auth/login"));
};
